import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { CryptPasswordService } from 'app/shared/services/crypt-password/crypt-password.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  @Input() mailPassword: boolean;
  @Output() newMailPassword = new EventEmitter<boolean>();

  loginForm: FormGroup;
  submitted: boolean;
  returnUrl: string;
  error: object;
  errorUsernamePassword = false;
  loading = false;
  inactive = false;

  logIn: boolean;

  constructor(
    private userService: UserService,
    private dataService: DataService,
    private uiService: UiService,
    private formBuilder: FormBuilder,
    private cryptPasswordService: CryptPasswordService,
    private authenticationService: AuthenticationService,
    public router: Router,
    private ffvService: FfvapiService,
    private route: ActivatedRoute,


  ) { }

  ngOnInit(): void {

    this.initForm();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.isLogIn();


  }

  onSubmit(): void {
    this.submitted = true;


    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.errorsManage();
      return;
    }


    this.loading = true;
    const valueToSend = this.cryptPasswordService.cryptPassword(this.f.password.value);
    // this.authenticationService.login(this.f.username.value, valueToSend, this.f.role.value)
    this.authenticationService.login(this.f.username.value, valueToSend)
      .pipe(first())
      .subscribe(
        data => {
          this.router.navigate([this.returnUrl]);
          this.dataService.isConnect.next(true);
          this.getMenu();
          // if (this.logIn) {
          this.ffvService.checkIfALicence().subscribe(res => {
            this.dataService.userIsLink.next(true);

            this.ffvService.getDetailsUser().subscribe(response => {

              response.prenom.toLocaleLowerCase()[0].toUpperCase();

              const userLogin = this.authenticationService.getDecodedToken();
              userLogin.given_name = response.prenom;
              userLogin.family_name = response.nom;


              this.dataService.userLogin.next(userLogin);
            }, error => {

              this.dataService.userLogin.next(this.authenticationService.getDecodedToken());

            });
          }, error => {

            this.dataService.userLogin.next(this.authenticationService.getDecodedToken());

          });
          // }
        },
        error => {
          this.error = error;

          if (error.status === 400) {
            this.errorUsernamePassword = true;
            this.uiService.openSnackBar(`Nom d'utilisateur ou mot de passe incorrect`, '');
          }
          this.loading = false;
          this.loginForm.reset({
            username: this.f.username.value,
            password: ''
          });
        });
  }

  isInactive(inputValue: string): void {
    inputValue ? this.inactive = true : this.inactive = false;
  }
  back(): void {
    this.newMailPassword.emit(false);
  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }

  private errorsManage(): void {
    if (this.f.password.errors?.required && this.f.username.errors?.required) {
      this.uiService.openSnackBar(`Les champs sont vides`, '');
    } else {
      if (this.f.username.errors?.required) {
        this.uiService.openSnackBar(`Email ou licence requis`, '');
      }
      if (this.f.password.errors?.required) {
        this.uiService.openSnackBar(`Mot de passe requis`, '');
      }
      if (!this.f.email.valid) {
        this.uiService.openSnackBar(`Email invalide`, '');
      }
    }
  }

  private initForm(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  private isLogIn(): void {
    this.logIn = this.dataService.isLogIn(this.authenticationService.currentUserValue);
    this.logIn ? this.router.navigate(['/']) : this.router.navigate(['/login']);
  }

}
